<template>
  <div>
    <div class="px-4">
      <div class="body p-4">
        <span class="text-primary h2 d-flex align-items-center">
          <span class="text-gray"> Servi&ccedil;os</span>
        </span>

        <div class="text-end mt-4">
          <button
            type="button"
            class="px-3 btn text-uppercase font-weight-light btn-secondary text-white btn-shadow mb-2 btn-sm"
            @click="$router.push('/cliente/nfse/servicos/novo')"
            v-prevent-click
          >
            <i class="fas fa-plus me-2"></i>Cadastrar servi&ccedil;o
          </button>
        </div>

        <div class="d-flex justify-content-center mt-4" v-if="loaderActive">
          <div class="spinner-border text-primary spinner-border" role="status">
            <span class="visually-hidden">Aguarde...</span>
          </div>
        </div>

        <div class="card p-3 mt-4 text-start" v-else-if="!services.length">
          Sem servi&ccedil;os cadastrados.
        </div>

        <div class="card p-3 mt-4 text-start" v-else>
          <div class="table-responsive">
            <table class="table table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>Descri&ccedil;&atilde;o padr&atilde;o</th>
                  <th>CNAE</th>
                  <th>Pre&ccedil;o padr&atilde;o</th>
                  <th>Cadastro fiscal</th>
                  <th>Ativo</th>
                  <th>Criado em</th>
                  <th>Atualizado em</th>
                  <th class="text-center">A&ccedil;&otilde;es</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="service in services" :key="service.id">
                  <td>{{ service.id }}</td>
                  <td>{{ service.name || "-" }}</td>
                  <td>{{ service.default_description || "-" }}</td>
                  <td>{{ service.cnae || "-" }}</td>
                  <td>{{ formatCurrency(service.default_price) }}</td>
                  <td>
                    <span
                      class="badge"
                      :class="isIncomplete(service) ? 'bg-warning text-dark' : 'bg-success'"
                      v-tooltip="fiscalTooltip(service)"
                    >{{ isIncomplete(service) ? "Incompleto" : "Completo" }}</span>
                  </td>
                  <td>
                    <span
                      class="badge"
                      :class="service.is_active ? 'bg-success' : 'bg-secondary'"
                    >{{ service.is_active ? "Sim" : "Não" }}</span>
                  </td>
                  <td>{{ formatDate(service.created_at) }}</td>
                  <td>{{ formatDate(service.updated_at) }}</td>
                  <td>
                    <div class="d-flex justify-content-center">
                      <button
                        class="btn btn-light shadow-sm me-2"
                        type="button"
                        v-tooltip="'Editar'"
                        @click="$router.push(`/cliente/nfse/servicos/editar/${service.id}`)"
                      >
                        <i class="fas fa-edit text-primary"></i>
                      </button>
                      <button
                        class="btn btn-light shadow-sm me-2"
                        type="button"
                        v-tooltip="'Perfis municipais'"
                        @click="$router.push(`/cliente/nfse/servicos/${service.id}/municipios`)"
                      >
                        <i class="fas fa-city text-secondary"></i>
                      </button>
                      <button
                        class="btn btn-light shadow-sm"
                        type="button"
                        v-tooltip="'Remover'"
                        @click="deleteService(service)"
                      >
                        <i class="fas fa-trash text-danger"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import {
  getErrorMessage,
  isNfseServiceIncomplete,
  nfseServiceMissingFields,
} from "@/utils/nfseHelpers";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: "nfse-services-list",
  data() {
    return {
      services: [],
      loaderActive: false,
    };
  },
  async mounted() {
    await this.loadServices();
  },
  methods: {
    normalizeList(data) {
      if (Array.isArray(data)) return data;
      if (Array.isArray(data.data)) return data.data;
      return [];
    },
    isIncomplete(service) {
      return isNfseServiceIncomplete(service);
    },
    fiscalTooltip(service) {
      const missing = nfseServiceMissingFields(service);
      if (!missing.length) return "Pronto para emissão";
      return `Não é possível emitir — falta: ${missing.join(", ")}`;
    },
    async loadServices() {
      try {
        this.loaderActive = true;
        const { data } = await api.get("/company/nfse/services");
        this.services = this.normalizeList(data);
      } catch (e) {
        toast.error(
          getErrorMessage(e, "Ocorreu um erro ao carregar os serviços.")
        );
      } finally {
        this.loaderActive = false;
      }
    },
    async deleteService(service) {
      const confirmed = window.confirm(
        `Deseja remover o serviço #${service.id}?`
      );
      if (!confirmed) return;

      try {
        this.loaderActive = true;
        await api.delete(`/company/nfse/services/${service.id}`);
        toast.success("Serviço removido com sucesso.");
        await this.loadServices();
      } catch (e) {
        toast.error(
          getErrorMessage(e, "Ocorreu um erro ao remover o serviço.")
        );
      } finally {
        this.loaderActive = false;
      }
    },
    formatDate(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString("pt-BR");
    },
    formatCurrency(value) {
      if (value == null) return "-";
      return Number(value).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  },
};
</script>
